// rdesc comes as "Player#Method" — reference shows "Method by Player"
// (e.g. "Header Goal by Luis Suarez"). A no-goal round comes as "No Goal#No
// Goal" and reads just "No Goal" (user 2026-10-15), like the player site.
function formatGoalResult(rdesc) {
  if (!rdesc) return '';
  const [player, method] = String(rdesc).split('#').map((s) => s.trim());
  if (!method) return player;
  if (/^no goal$/i.test(method) || /^no goal$/i.test(player)) return 'No Goal';
  return `${method} by ${player}`;
}

export default function GoalResult({ detail }) {
  return (
    <div className="d-flex justify-content-center">
      <div className="cricket20ballpopup cricket20ballresult goalresult">
        <img src="https://wver.sprintstaticdata.com/v230/static/admin/img/balls/soccer-ball.png" />
        {' '}
        <span>{formatGoalResult(detail?.rdesc)}</span>
      </div>
    </div>
  );
}
